
export namespace OperationsSymbolAction {

  export class FetchOperationsSymbol {

    static readonly type = '[OperationsSymbolAction] Fetch operations symbol';
    constructor(public id: number, public hideLoading = false) {}
  }

}
